import React from 'react';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Icon } from '../KeyComponents';
import { IconButton } from '../Button';
import TextInput from '../TextInput';
import { useToast } from '../BlendxToast/ToastContext';

function ShareButtonComponent(props) {
  const { url } = props;
  const showToast = useToast();
  const handleShare = (platform) => {
    let shareUrl = '';

    switch (platform) {
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`;
        break;
      case 'twitter':
        shareUrl = `https://x.com/intent/tweet?url=${encodeURIComponent(url)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, '_blank');
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(url).then(() => {
      showToast('check', 'success', 'Link copied to clipboard');
    }).catch(err => {
      showToast('close', 'error', 'Failed to copy Link');
      console.error('Failed to copy link:', err);
    });
  };

  const handleKeyPress = (event, platform) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleShare(platform);
    }
  };

  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle as={IconButton} icon="share-forward" variant="ghost-gray" type="line" size="md" />
        <Dropdown.Menu className="share-component-dropdown">
          <div className="share-component-wrapper">
            <div className="share-component__top-section">
              <span className="share-component__heading-label">Share on with</span>
              <div className="share-component__share-btn-row">
                {['whatsapp', 'linkedin', 'facebook', 'twitter'].map((platform, index) => (
                  <div
                    key={index}
                    className={`share-component__share-btn ${platform}-btn`}
                    onClick={() => handleShare(platform)}
                    onKeyPress={(event) => handleKeyPress(event, platform)}
                    tabIndex={0} // Make it focusable
                    role="button" // Make it accessible
                  >
                    <Icon className="share-component__social-media-icon" icon={platform} type="fill" />
                  </div>
                ))}
              </div>
            </div>
            <div className="share-component__bottom-section">
              <TextInput className="bottom-section__text-input" size="xs" value={url} readOnly />
              <IconButton icon="file-copy" variant="outline-gray" type="line" size="xs" onClick={handleCopyUrl} />
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

ShareButtonComponent.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ShareButtonComponent;
